import BigNumber from 'bignumber.js'
import numeral from 'numeral'
import { useMemo } from 'react'
import { useAccount } from 'wagmi'

import MyRewards from '@/assets/myrewards.png'
import WanPos from '@/assets/wanPos.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { useQueryPosStakeInfo, useQueryTokenPrice } from '@/utils/queries'

import { useDelegatorStakeInfo, useDelegatorTotalIncentive } from './pos-data'
import PosLists from './pos-lists'
import PosStatisticsModule from './pos-statistics'
import {
  Con,
  Container,
  Data,
  Data1,
  Gap,
  Img,
  LineStyle,
  PosStatistics,
  PosTvlInUsd,
  PosTvlInUsdMedia,
  StatisticsAvg,
  StatisticsTitle,
  StatisticsTvl,
} from './Pos.module'

export default function Pos() {
  const { address } = useAccount()
  const { data: posStakeInfo } = useQueryPosStakeInfo()
  const { theme } = useLocalStorage()
  const delegatorStakeInfo = useDelegatorStakeInfo()
  const delegatorTotalIncentive = useDelegatorTotalIncentive()
  const { data: tokensPrice, isLoading: tokensPriceLoading } =
    useQueryTokenPrice()

  const isdark = useMemo(() => theme === 'dark', [theme])

  const stakerList = useMemo(() => {
    if (
      posStakeInfo &&
      posStakeInfo.stakers &&
      posStakeInfo.stakers.length > 0 &&
      (!address || delegatorStakeInfo.done)
    ) {
      posStakeInfo.stakers.forEach((i: any) => {
        i.myDelegate = '0'
        i.myTotalIncentive = '0'
        delegatorStakeInfo.forEach((j: any) => {
          if (i.address.toLowerCase() === j.address.toLowerCase()) {
            i.myDelegate = j.amount.toString()
          }
        })
        delegatorTotalIncentive.forEach((t: any) => {
          if (i.address.toLowerCase() === t.address.toLowerCase()) {
            i.myTotalIncentive = new BigNumber(i.myTotalIncentive)
              .plus(t.amount)
              .toString()
          }
        })
      })
      return posStakeInfo.stakers
    } else {
      return []
    }
  }, [address, delegatorStakeInfo, delegatorTotalIncentive, posStakeInfo])

  const WanPrice = useMemo(() => {
    if (!tokensPriceLoading && tokensPrice) {
      return tokensPrice.wanchain?.usd || '0'
    } else {
      return '0'
    }
  }, [tokensPrice, tokensPriceLoading])

  const myAllDelegates = useMemo(() => {
    return delegatorStakeInfo.reduce(
      (prev: string, i: { amount: string }) =>
        new BigNumber(prev).plus(i.amount).toString(),
      0,
    )
  }, [delegatorStakeInfo])

  const myAllDelegatesInUsd = useMemo(() => {
    const tmp = new BigNumber(WanPrice)
      .multipliedBy(myAllDelegates || '0')
      .toString()
    return numeral(tmp).format('0,0')
  }, [WanPrice, myAllDelegates])

  const myTotalIncentive = useMemo(() => {
    return delegatorTotalIncentive.reduce(
      (prev: string, i: { amount: string }) =>
        new BigNumber(prev).plus(i.amount).toString(),
      0,
    )
  }, [delegatorTotalIncentive])

  return (
    <Container>
      {/* Total  */}
      <PosStatisticsModule />
      <Gap />
      {/* Personal  */}
      {new BigNumber(myAllDelegates).gt('0') && (
        <PosStatistics className="bg-white dark:bg-common-1">
          <StatisticsTvl>
            <StatisticsTitle className="text-light-0 dark:text-dark-0">
              My Delegations
              <PosTvlInUsd>
                <Data1>{myAllDelegatesInUsd} USD</Data1>
              </PosTvlInUsd>
            </StatisticsTitle>
            <Con>
              <Img src={WanPos} alt="WanPos" />
              <Data>
                <div className="text-light-111 dark:text-white">
                  {numeral(myAllDelegates)
                    .format('0,0.00')
                    .replace(/\.?0+$/, '')}{' '}
                  <Data1>WAN</Data1>
                </div>
                <PosTvlInUsdMedia>
                  <Data1>{myAllDelegatesInUsd} USD</Data1>
                </PosTvlInUsdMedia>
              </Data>
            </Con>
          </StatisticsTvl>
          <LineStyle isdark={isdark} />
          <StatisticsAvg>
            <StatisticsTitle className="text-light-0 dark:text-dark-0">
              My Rewards
            </StatisticsTitle>
            <Con>
              <Img src={MyRewards} alt="Rewards" />
              <Data>
                <div className="text-light-222 dark:text-white">
                  {numeral(myTotalIncentive)
                    .format('0,0.00')
                    .replace(/\.?0+$/, '')}{' '}
                  <Data1>WAN</Data1>
                </div>
              </Data>
            </Con>
          </StatisticsAvg>
        </PosStatistics>
      )}
      <PosLists stakerList={stakerList} />
    </Container>
  )
}
